// Reusable form field (input / textarea) with label + optional error
export const FormInput = ({
  label,
  id,
  type = "text",
  as = "input",
  error,
  onDark = false,
  className = "",
  testId,
  ...rest
}) => {
  const fieldBase = `w-full rounded-lg border px-4 py-3 text-sm outline-none transition-colors duration-200 ${
    onDark
      ? "border-white/15 bg-white/5 text-white placeholder:text-white/40 focus:border-orange"
      : "border-navy/15 bg-white text-navy placeholder:text-navy/40 focus:border-royal"
  } ${error ? "border-destructive" : ""}`;

  return (
    <div className={`flex flex-col gap-2 ${className}`}>
      {label && (
        <label
          htmlFor={id}
          className={`text-xs font-semibold uppercase tracking-wider ${
            onDark ? "text-white/70" : "text-navy/70"
          }`}
        >
          {label}
        </label>
      )}
      {as === "textarea" ? (
        <textarea id={id} data-testid={testId} className={`${fieldBase} min-h-[130px] resize-y`} {...rest} />
      ) : (
        <input id={id} type={type} data-testid={testId} className={fieldBase} {...rest} />
      )}
      {error && (
        <span className="text-xs text-destructive" data-testid={testId ? `${testId}-error` : undefined}>
          {error}
        </span>
      )}
    </div>
  );
};
